/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bzHsBkgGqqFqgQ8Ug5BFVy
// Component: vvUax3hU1ZOa
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useGlobalVariants } from "../haaaven_1_1_4_prod/plasmic"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectModule
import { _useStyleTokens } from "../haaaven_1_1_4_prod/PlasmicStyleTokensProvider"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "../haaaven_1_1_4_prod/plasmic.css"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectcss
import sty from "./PlasmicCristianPopa.module.css"; // plasmic-import: vvUax3hU1ZOa/css
import Icon8Icon from "../haaaven_1_1_4_prod/icons/PlasmicIcon__Icon8"; // plasmic-import: 4PXEnoMcmxWn/icon
import IconIcon from "../haaaven_1_1_4_prod/icons/PlasmicIcon__Icon"; // plasmic-import: M6UJ_nikhUMm/icon
import Icon3Icon from "../haaaven_1_1_4_prod/icons/PlasmicIcon__Icon3"; // plasmic-import: nGQyuSCWzfEK/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "cristian popa",
    openGraph: {
      title: "cristian popa"
    },
    twitter: {
      card: "summary",
      title: "cristian popa"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicCristianPopa__VariantProps = new Array();

export const PlasmicCristianPopa__ArgProps = new Array();

const $$ = {};

function PlasmicCristianPopa__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_bzHsBkgGqqFqgQ8Ug5BFVy",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root,
          "auto-scroll"
        )}
      >
        <section
          data-plasmic-name={"section"}
          data-plasmic-override={overrides.section}
          className={classNames("all", sty.section)}
        >
          <div
            data-plasmic-name={"container"}
            data-plasmic-override={overrides.container}
            className={classNames("all", sty.container)}
          >
            <div
              data-plasmic-name={"nav"}
              data-plasmic-override={overrides.nav}
              className={classNames("all", sty.nav)}
            >
              <div
                data-plasmic-name={"columnsForNav"}
                data-plasmic-override={overrides.columnsForNav}
                className={classNames("all", sty.columnsForNav)}
              >
                <div
                  data-plasmic-name={"column1Wrapper2"}
                  data-plasmic-override={overrides.column1Wrapper2}
                  className={classNames("all", sty.column1Wrapper2)}
                >
                  <div className={classNames("all", sty.freeBox__uP4Xq)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__kEsSe
                      )}
                    >
                      {"a."}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"column2Wrapper2"}
                  data-plasmic-override={overrides.column2Wrapper2}
                  className={classNames("all", sty.column2Wrapper2)}
                >
                  <div className={classNames("all", sty.freeBox__aoPqS)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__f0Dt
                      )}
                    >
                      {"DIGITAL FOOTPRINT"}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"column2Wrapper3"}
                  data-plasmic-override={overrides.column2Wrapper3}
                  className={classNames("all", sty.column2Wrapper3)}
                >
                  <div className={classNames("all", sty.freeBox__fauXx)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__vOsZi
                      )}
                    >
                      {"CONTACT"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"columns"}
              data-plasmic-override={overrides.columns}
              className={classNames("all", sty.columns)}
            >
              <div
                data-plasmic-name={"column1Wrapper"}
                data-plasmic-override={overrides.column1Wrapper}
                className={classNames("all", sty.column1Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection"}
                  data-plasmic-override={overrides.heroSection}
                  className={classNames("all", sty.heroSection)}
                >
                  <div
                    data-plasmic-name={"logoMarkWrapper"}
                    data-plasmic-override={overrides.logoMarkWrapper}
                    className={classNames("all", sty.logoMarkWrapper)}
                  >
                    <Icon8Icon
                      data-plasmic-name={"logoMarkIocn"}
                      data-plasmic-override={overrides.logoMarkIocn}
                      className={classNames("all", sty.logoMarkIocn)}
                      onClick={async event => {
                        const $steps = {};
                        $steps["goToHomepage"] = true
                          ? (() => {
                              const actionArgs = { destination: `/` };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToHomepage"] != null &&
                          typeof $steps["goToHomepage"] === "object" &&
                          typeof $steps["goToHomepage"].then === "function"
                        ) {
                          $steps["goToHomepage"] = await $steps["goToHomepage"];
                        }
                      }}
                      role={"img"}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__hehrI)}>
                    <h1
                      data-plasmic-name={"h1"}
                      data-plasmic-override={overrides.h1}
                      className={classNames(
                        "all",
                        "h1",
                        "h1__bzHsB",
                        "__wab_text",
                        sty.h1
                      )}
                    >
                      {"cristian popa"}
                    </h1>
                    <div className={classNames("all", sty.freeBox__avfyg)}>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__j8OXk
                        )}
                      >
                        {
                          "My personal mission is to create a foundation for uninhibited self-expression for myself, my people, and others."
                        }
                      </p>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bzHsB",
                          "__wab_text",
                          sty.p__yajkK
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"I\u2019m currently working on [ "}
                          </React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__ffkbQ
                              )}
                              href={"https://o21p.com/"}
                              platform={"react"}
                            >
                              {"o21p.com"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{" ]."}</React.Fragment>
                        </React.Fragment>
                      </p>
                    </div>
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox__nsuYh)}>
                  <div
                    className={classNames("all", "__wab_text", sty.text__dqkcm)}
                  >
                    {"\u00a9 2026 haaaven - all rights reserved."}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"column2Wrapper"}
                data-plasmic-override={overrides.column2Wrapper}
                className={classNames("all", sty.column2Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection4"}
                  data-plasmic-override={overrides.heroSection4}
                  className={classNames("all", sty.heroSection4)}
                >
                  <div
                    data-plasmic-name={"projectWrapper6"}
                    data-plasmic-override={overrides.projectWrapper6}
                    className={classNames("all", sty.projectWrapper6)}
                  >
                    <div className={classNames("all", sty.freeBox__t0B3U)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__bde2
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__g6Eag
                              )}
                              href={"https://www.instagram.com/cristiaaanpopa/"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"Instagram"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__oIVb0
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__gNc25
                              )}
                              href={"https://x.com/cristiaaanpopa"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"X"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text___9A7Zo
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link___1YSIv
                              )}
                              href={"https://www.linkedin.com/in/cristiaaan/"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"LinkedIn"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__x66Pn
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__ymOuq
                              )}
                              href={"https://www.youtube.com/@cristiaaanpopa"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"YouTube"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__ytrup
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__z1Ngy
                              )}
                              href={"https://strava.app.link/0UW4RxZxoZb"}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                  }
                                  style={{ color: "#FFFFFF" }}
                                >
                                  {"Strava"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"column3Wrapper"}
                data-plasmic-override={overrides.column3Wrapper}
                className={classNames("all", sty.column3Wrapper)}
              >
                <div
                  data-plasmic-name={"heroSection5"}
                  data-plasmic-override={overrides.heroSection5}
                  className={classNames("all", sty.heroSection5)}
                >
                  <div
                    data-plasmic-name={"projectWrapper8"}
                    data-plasmic-override={overrides.projectWrapper8}
                    className={classNames("all", sty.projectWrapper8)}
                  >
                    <div className={classNames("all", sty.freeBox__bn1Fl)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__wQhi5
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"cristian@haaaven.com"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {(hasVariant(globalVariants, "screen", "mobile") ? true : false) ? (
          <div
            data-plasmic-name={"columnsMobile"}
            data-plasmic-override={overrides.columnsMobile}
            className={classNames("all", sty.columnsMobile)}
          >
            <div
              data-plasmic-name={"column1Wrapper4"}
              data-plasmic-override={overrides.column1Wrapper4}
              className={classNames("all", sty.column1Wrapper4)}
            >
              <div
                data-plasmic-name={"heroSection3"}
                data-plasmic-override={overrides.heroSection3}
                className={classNames("all", sty.heroSection3)}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text___5OQNb)}
                >
                  {"a."}
                </div>
                <div className={classNames("all", sty.freeBox__vIir)}>
                  <IconIcon
                    className={classNames("all", sty.svg__b0Guo)}
                    role={"img"}
                  />
                </div>
              </div>
              <div
                data-plasmic-name={"esseySection3"}
                data-plasmic-override={overrides.esseySection3}
                className={classNames("all", sty.esseySection3)}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__jpWs7)}
                >
                  {"a haven for creativity in a technological world."}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text__op5YB)}
                >
                  {
                    "Why do you have to go to school?\nWhy do you need a smartphone?\nWhy stop at a red light when there is absolutely no one around?...\n\nAs societal systems embed themselves into every aspect of our lives, the relentless pursuit of efficiency threatens to erase the essence of what makes us human. With each small compromise, made for the sake of convenience and the comfort of conformity, we gradually erode our autonomy. Step by step, we trade creativity and individuality for predictable outcomes, quietly surrendering our unique impulses to a system that prioritizes uniformity over genuine human experience.\n\nSooner or later, the pervasive influence of efficiency will overshadow human creative expression. When that moment comes, how will you make sure you have the agency to make the choices that align with who you are and want to become?\n\n\u2026"
                  }
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__iIbrU)}>
                <div
                  data-plasmic-name={"projectWrapper9"}
                  data-plasmic-override={overrides.projectWrapper9}
                  className={classNames("all", sty.projectWrapper9)}
                >
                  <div className={classNames("all", sty.freeBox__evGch)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__bMbrU
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__hXruo)}
                  >
                    {
                      "We\u2019re rebuilding practice management systems from the ground up, letting independent professionals shape their tools (not the other way around), and putting good design at the heart of healthcare tech."
                    }
                  </div>
                </div>
                <div
                  data-plasmic-name={"projectWrapper10"}
                  data-plasmic-override={overrides.projectWrapper10}
                  className={classNames("all", sty.projectWrapper10)}
                >
                  <div
                    className={classNames("all", "__wab_text", sty.text__kpb13)}
                  >
                    {"human user interface."}
                  </div>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___0PMd3
                    )}
                  >
                    {"Infrastructure design research."}
                  </div>
                </div>
              </div>
              <div className={classNames("all", "__wab_text", sty.text__mc07)}>
                {"\u00a9 2025 HAAAVEN SRL. All rights reserved."}
              </div>
            </div>
          </div>
        ) : null}
        {(
          hasVariant(globalVariants, "screen", "mobile")
            ? true
            : hasVariant(globalVariants, "screen", "tablet")
              ? true
              : false
        ) ? (
          <div
            data-plasmic-name={"columnsMobile2"}
            data-plasmic-override={overrides.columnsMobile2}
            className={classNames("all", sty.columnsMobile2)}
          >
            <div
              data-plasmic-name={"column1Wrapper5"}
              data-plasmic-override={overrides.column1Wrapper5}
              className={classNames("all", sty.column1Wrapper5)}
            >
              <div
                data-plasmic-name={"heroSection6"}
                data-plasmic-override={overrides.heroSection6}
                className={classNames("all", sty.heroSection6)}
              >
                <div
                  data-plasmic-name={"logoMarkWrapp"}
                  data-plasmic-override={overrides.logoMarkWrapp}
                  className={classNames("all", sty.logoMarkWrapp)}
                >
                  <Icon8Icon
                    className={classNames("all", sty.svg__loD32)}
                    onClick={async event => {
                      const $steps = {};
                      $steps["goToHomepage"] = true
                        ? (() => {
                            const actionArgs = { destination: `/` };
                            return (({ destination }) => {
                              if (
                                typeof destination === "string" &&
                                destination.startsWith("#")
                              ) {
                                document
                                  .getElementById(destination.substr(1))
                                  .scrollIntoView({ behavior: "smooth" });
                              } else {
                                location.assign(destination);
                              }
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["goToHomepage"] != null &&
                        typeof $steps["goToHomepage"] === "object" &&
                        typeof $steps["goToHomepage"].then === "function"
                      ) {
                        $steps["goToHomepage"] = await $steps["goToHomepage"];
                      }
                    }}
                    role={"img"}
                  />
                </div>
                <div className={classNames("all", sty.freeBox__wo5Pt)}>
                  <div className={classNames("all", sty.freeBox__gvM24)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___0JS0
                      )}
                    >
                      {"cristian popa"}
                    </div>
                    <div className={classNames("all", sty.freeBox__l3Lbl)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__pbVxr
                        )}
                      >
                        {
                          "My personal mission is to create a foundation for uninhibited self-expression for myself, my people, and others."
                        }
                      </div>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__vQd8R
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"I\u2019m currently working on [ "}
                          </React.Fragment>
                          {
                            <PlasmicLink__
                              className={classNames(
                                "all",
                                "a",
                                "a__bzHsB",
                                "__wab_text",
                                "plasmic_default__inline",
                                sty.link__pRtI
                              )}
                              href={"https://o21p.com/"}
                              platform={"react"}
                            >
                              {"o21p.com"}
                            </PlasmicLink__>
                          }
                          <React.Fragment>{" ]."}</React.Fragment>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__nb69K)}>
                <div
                  data-plasmic-name={"projectWrapper11"}
                  data-plasmic-override={overrides.projectWrapper11}
                  className={classNames("all", sty.projectWrapper11)}
                >
                  <div className={classNames("all", sty.freeBox__ozpw)}>
                    <Icon3Icon
                      className={classNames("all", sty.svg__ypCea)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__gDm9G
                      )}
                    >
                      {"PORTFOLIO PROJECT."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox___0BGbd)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__cYlMv
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__t76Zl)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___9BlTo
                      )}
                    >
                      {"// DIGITAL FOOTPRINT"}
                    </div>
                    <div className={classNames("all", sty.freeBox__ljVjZ)}>
                      <div className={classNames("all", sty.freeBox__ttqpt)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__gSqVq
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__tKBz
                                )}
                                href={
                                  "https://www.instagram.com/cristiaaanpopa/"
                                }
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"Instagram"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__obLBa)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___65UOk
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__pzlBs
                                )}
                                href={"https://x.com/cristiaaanpopa"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"X"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__pRbUy)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__thgE
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link___9HK3O
                                )}
                                href={"https://www.linkedin.com/in/cristiaaan/"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"LinkedIn"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__u5Dnw)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__fuR4X
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__qtSzq
                                )}
                                href={"https://www.youtube.com/@cristiaaanpopa"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"YouTube"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                      <div className={classNames("all", sty.freeBox__myV3O)}>
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__ed8YS
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  "all",
                                  "a",
                                  "a__bzHsB",
                                  "__wab_text",
                                  "plasmic_default__inline",
                                  sty.link__uRu6R
                                )}
                                href={"https://strava.app.link/0UW4RxZxoZb"}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                    }
                                    style={{ color: "#FFFFFF" }}
                                  >
                                    {"Strava"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                              }
                              style={{ color: "#FFFFFF" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__efQia)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__cEpOr
                      )}
                    >
                      {"// CONTACT"}
                    </div>
                    <div className={classNames("all", sty.freeBox__vGdd3)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__yf48U
                        )}
                      >
                        <React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                            }
                            style={{ color: "#FFFFFF" }}
                          >
                            {"cristian@haaaven.com"}
                          </span>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"projectWrapper12"}
                  data-plasmic-override={overrides.projectWrapper12}
                  className={classNames("all", sty.projectWrapper12)}
                >
                  <div className={classNames("all", sty.freeBox__lTwKd)}>
                    <Icon3Icon
                      className={classNames("all", sty.svg__dBsC)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text___4OvAp
                      )}
                    >
                      {"PORTFOLIO PROJECT."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox___7AekJ)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__lTvaB
                      )}
                    >
                      {"OP for my practice."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__hstSe)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__qKeQc
                      )}
                    >
                      {"nexus"}
                    </div>
                    <div
                      className={classNames("all", "__wab_text", sty.text__ghE)}
                    >
                      {"Working on it..."}
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__q84DL)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__q58Tw
                      )}
                    >
                      {"WEBSITE."}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__k5Z1Z
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {"[ "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bzHsB",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link__zBh8U
                            )}
                            href={"https://nexus.o21p.com/"}
                            platform={"react"}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                }
                                style={{ color: "#FFFFFF" }}
                              >
                                {"nexus.o21p.com"}
                              </span>
                            </React.Fragment>
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {" ]"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                  <div className={classNames("all", sty.freeBox__rStW5)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__nZphT
                      )}
                    >
                      {"CONTRIBUTORS."}
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__cgbT
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {"[ "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bzHsB",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link___3Ly0Q
                            )}
                            href={"https://x.com/cristiaaanpopa"}
                            platform={"react"}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                                }
                                style={{ color: "#FFFFFF" }}
                              >
                                {"cristian popa"}
                              </span>
                            </React.Fragment>
                          </PlasmicLink__>
                        }
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bzHsB"
                          }
                          style={{ color: "#FFFFFF" }}
                        >
                          {" ]"}
                        </span>
                      </React.Fragment>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames("all", "__wab_text", sty.text__dAcV)}>
                {"\u00a9 2026 haaaven - all rights reserved."}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "section",
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "h1",
    "column2Wrapper",
    "heroSection4",
    "projectWrapper6",
    "column3Wrapper",
    "heroSection5",
    "projectWrapper8",
    "columnsMobile",
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10",
    "columnsMobile2",
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "projectWrapper11",
    "projectWrapper12"
  ],

  section: [
    "section",
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "h1",
    "column2Wrapper",
    "heroSection4",
    "projectWrapper6",
    "column3Wrapper",
    "heroSection5",
    "projectWrapper8"
  ],

  container: [
    "container",
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3",
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "h1",
    "column2Wrapper",
    "heroSection4",
    "projectWrapper6",
    "column3Wrapper",
    "heroSection5",
    "projectWrapper8"
  ],

  nav: [
    "nav",
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3"
  ],

  columnsForNav: [
    "columnsForNav",
    "column1Wrapper2",
    "column2Wrapper2",
    "column2Wrapper3"
  ],

  column1Wrapper2: ["column1Wrapper2"],
  column2Wrapper2: ["column2Wrapper2"],
  column2Wrapper3: ["column2Wrapper3"],
  columns: [
    "columns",
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "h1",
    "column2Wrapper",
    "heroSection4",
    "projectWrapper6",
    "column3Wrapper",
    "heroSection5",
    "projectWrapper8"
  ],

  column1Wrapper: [
    "column1Wrapper",
    "heroSection",
    "logoMarkWrapper",
    "logoMarkIocn",
    "h1"
  ],

  heroSection: ["heroSection", "logoMarkWrapper", "logoMarkIocn", "h1"],
  logoMarkWrapper: ["logoMarkWrapper", "logoMarkIocn"],
  logoMarkIocn: ["logoMarkIocn"],
  h1: ["h1"],
  column2Wrapper: ["column2Wrapper", "heroSection4", "projectWrapper6"],
  heroSection4: ["heroSection4", "projectWrapper6"],
  projectWrapper6: ["projectWrapper6"],
  column3Wrapper: ["column3Wrapper", "heroSection5", "projectWrapper8"],
  heroSection5: ["heroSection5", "projectWrapper8"],
  projectWrapper8: ["projectWrapper8"],
  columnsMobile: [
    "columnsMobile",
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10"
  ],

  column1Wrapper4: [
    "column1Wrapper4",
    "heroSection3",
    "esseySection3",
    "projectWrapper9",
    "projectWrapper10"
  ],

  heroSection3: ["heroSection3"],
  esseySection3: ["esseySection3"],
  projectWrapper9: ["projectWrapper9"],
  projectWrapper10: ["projectWrapper10"],
  columnsMobile2: [
    "columnsMobile2",
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "projectWrapper11",
    "projectWrapper12"
  ],

  column1Wrapper5: [
    "column1Wrapper5",
    "heroSection6",
    "logoMarkWrapp",
    "projectWrapper11",
    "projectWrapper12"
  ],

  heroSection6: ["heroSection6", "logoMarkWrapp"],
  logoMarkWrapp: ["logoMarkWrapp"],
  projectWrapper11: ["projectWrapper11"],
  projectWrapper12: ["projectWrapper12"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCristianPopa__ArgProps,
          internalVariantPropNames: PlasmicCristianPopa__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCristianPopa__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCristianPopa";
  } else {
    func.displayName = `PlasmicCristianPopa.${nodeName}`;
  }
  return func;
}

export const PlasmicCristianPopa = Object.assign(
  // Top-level PlasmicCristianPopa renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    section: makeNodeComponent("section"),
    container: makeNodeComponent("container"),
    nav: makeNodeComponent("nav"),
    columnsForNav: makeNodeComponent("columnsForNav"),
    column1Wrapper2: makeNodeComponent("column1Wrapper2"),
    column2Wrapper2: makeNodeComponent("column2Wrapper2"),
    column2Wrapper3: makeNodeComponent("column2Wrapper3"),
    columns: makeNodeComponent("columns"),
    column1Wrapper: makeNodeComponent("column1Wrapper"),
    heroSection: makeNodeComponent("heroSection"),
    logoMarkWrapper: makeNodeComponent("logoMarkWrapper"),
    logoMarkIocn: makeNodeComponent("logoMarkIocn"),
    h1: makeNodeComponent("h1"),
    column2Wrapper: makeNodeComponent("column2Wrapper"),
    heroSection4: makeNodeComponent("heroSection4"),
    projectWrapper6: makeNodeComponent("projectWrapper6"),
    column3Wrapper: makeNodeComponent("column3Wrapper"),
    heroSection5: makeNodeComponent("heroSection5"),
    projectWrapper8: makeNodeComponent("projectWrapper8"),
    columnsMobile: makeNodeComponent("columnsMobile"),
    column1Wrapper4: makeNodeComponent("column1Wrapper4"),
    heroSection3: makeNodeComponent("heroSection3"),
    esseySection3: makeNodeComponent("esseySection3"),
    projectWrapper9: makeNodeComponent("projectWrapper9"),
    projectWrapper10: makeNodeComponent("projectWrapper10"),
    columnsMobile2: makeNodeComponent("columnsMobile2"),
    column1Wrapper5: makeNodeComponent("column1Wrapper5"),
    heroSection6: makeNodeComponent("heroSection6"),
    logoMarkWrapp: makeNodeComponent("logoMarkWrapp"),
    projectWrapper11: makeNodeComponent("projectWrapper11"),
    projectWrapper12: makeNodeComponent("projectWrapper12"),
    // Metadata about props expected for PlasmicCristianPopa
    internalVariantProps: PlasmicCristianPopa__VariantProps,
    internalArgProps: PlasmicCristianPopa__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/cristian",
      pagePath: "/cristian",
      params: {},
      query: {}
    })
  }
);

export default PlasmicCristianPopa;
/* prettier-ignore-end */
